import { render, staticRenderFns } from "./DeliveryChart.vue?vue&type=template&id=e260a688&scoped=true&lang=pug&"
import script from "./DeliveryChart.vue?vue&type=script&lang=js&"
export * from "./DeliveryChart.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryChart.vue?vue&type=style&index=0&id=e260a688&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e260a688",
  null
  
)

/* custom blocks */
import block0 from "./DeliveryChart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports